/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {ProblemEntry} from "./problemEntry.zod";

export const problemResponseStatusMin = 100;
export const problemResponseStatusMax = 599;

export const ProblemResponse = zod
  .object({
    type: zod.url().describe("Problem type URI."),
    title: zod.string().describe("Short problem category title."),
    status: zod
      .int()
      .min(problemResponseStatusMin)
      .max(problemResponseStatusMax)
      .describe("HTTP status code."),
    detail: zod.string().describe("Human-readable primary problem detail."),
    code: zod.string().describe("Stable machine-readable primary problem code."),
    problems: zod
      .array(ProblemEntry)
      .min(1)
      .describe("All deterministic problems for this response."),
  })
  .describe("RFC-style Problem Details body with deterministic code and problem-list extensions.");

export type ProblemResponse = zod.input<typeof ProblemResponse>;
export type ProblemResponseOutput = zod.output<typeof ProblemResponse>;
